import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Raw, Repository } from 'typeorm';
import { EventcategoryDTO, EventcategoryStatusDTO } from './dto/eventcategory.dto';
import { AllEventcategoryResponseModel, EventcategoryResponseModel } from './eventcategory-respone-module';
import { EventscategoryEntity } from './eventcategory.entity';

@Injectable()
export class EventcategoryService {

    constructor(
        @InjectRepository(EventscategoryEntity)
        private EventcategoryRepository: Repository<EventscategoryEntity>,
    ) {}

    async createEventcategory(queryParams, EventcategoryDTO:EventcategoryDTO, request: Request): Promise<EventcategoryResponseModel> {
        const response = new EventcategoryResponseModel();
        try {
            const ActivityExists = await this.getEventcategoryWithoutRelations(EventcategoryDTO.category);
            if(ActivityExists) {
                throw new ErrorResponse(11104, 'category name already exists');
            } else {
                if(queryParams.apiVersion == 1) {
                    EventcategoryDTO.versionFlag = queryParams.apiVersion;
                    const savedActivity = await this.EventcategoryRepository.save(EventcategoryDTO);
                    if(savedActivity) {
                            response.status = true;
                            response.data   = savedActivity;
                            response.statusCode = 50000;
                            response.internalMessage = 'eventcategory created sucessfully';
                            response.intlCode = 11100;
                        }                       
                     else { 
                        throw new ErrorResponse(11106, 'eventcategory  not created')
                    }
                
                } else {
                    EventcategoryDTO.versionFlag = queryParams.apiVersion;
                    const savedActivity = await this.EventcategoryRepository.save(EventcategoryDTO);
                    if(savedActivity) {
                            response.status = true;
                            response.data   = savedActivity;
                            response.statusCode = 50000;
                            response.internalMessage = 'eventcategory created sucessfully';
                            response.intlCode = 11100;
                        }                       
                     else { 
                        throw new ErrorResponse(11106, 'eventcategory  not created')
                    }
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async getEventcategoryWithoutRelations(category: string): Promise<EventscategoryEntity> {
        const activityResponse = await this.EventcategoryRepository.findOne({
            where: {category: Raw(alias => `UPPER(category) = '${category.toLocaleUpperCase()}'`), status: true},
        });
        if(activityResponse) {
            return activityResponse;
        } else {
            return null;
        }
    }

    async getEventcategory(queryParams, request:Request): Promise<AllEventcategoryResponseModel> {
        const response = new AllEventcategoryResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const activeTypes = await this.EventcategoryRepository.find({
                    where: {status: true},
                    order: { createdAt: 'DESC' }
                });
                if(activeTypes) {
                    response.status = true;
                    response.data = activeTypes;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            } else {
                const activeTypes = await this.EventcategoryRepository.find({
                    where: {status: true},
                    order: { createdAt: 'DESC' }
                });
                if(activeTypes) {
                    response.status = true;
                    response.data = activeTypes;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async updateEventcategory(queryParams, EventcategoryDTO:EventcategoryDTO, request:Request): Promise<EventcategoryResponseModel> {
        const response = new EventcategoryResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const updateActivity = await this.EventcategoryRepository.update(EventcategoryDTO.Id,EventcategoryDTO);
                const updatedData = await this.EventcategoryRepository.findOne({
                    where:{Id:EventcategoryDTO.Id}
                });
                if(updateActivity) {
                   
                    response.status = true;
                    response.data   = updatedData;
                    response.statusCode = 50000;
                    response.internalMessage = 'eventcategory updated successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'eventcategory update failed')
                }
            } else {
                const updateActivity = await this.EventcategoryRepository.update(EventcategoryDTO.Id,EventcategoryDTO);
                const updatedData = await this.EventcategoryRepository.findOne({
                    where:{Id:EventcategoryDTO.Id}
                });
                if(updateActivity) {
                   
                    response.status = true;
                    response.data   = updatedData;
                    response.statusCode = 50000;
                    response.internalMessage = 'eventcategory updated successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'eventcategory update failed')
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async updateEventcategoryStatus(queryParams, EventcategoryStatusDTO:EventcategoryStatusDTO, request:Request): Promise<EventcategoryResponseModel> {
        const response = new EventcategoryResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const updateStatus = await this.EventcategoryRepository.update(EventcategoryStatusDTO.Id, EventcategoryStatusDTO);
                const updatedData = await this.EventcategoryRepository.findOne({
                    where:{Id:EventcategoryStatusDTO.Id}
                });
                if(updateStatus) {
                    response.status = true;
                    response.data   = updatedData;
                    response.statusCode = 50000;
                    response.internalMessage = 'Eventcategory status updated successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Eventcategory status update failed')
                }
            } else {
                const updateStatus = await this.EventcategoryRepository.update(EventcategoryStatusDTO.Id, EventcategoryStatusDTO);
                const updatedData = await this.EventcategoryRepository.findOne({
                    where:{Id:EventcategoryStatusDTO.Id}
                });
                if(updateStatus) {
                    response.status = true;
                    response.data   = updatedData;
                    response.statusCode = 50000;
                    response.internalMessage = 'Eventcategory status updated successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Eventcategory status update failed')
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }
}
